import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VolumeTotals } from '@app/shared/models/volume-dashboard.model';

@Component({
  selector: 'app-volume-kpi-grid',
  templateUrl: './volume-kpi-grid.component.html',
  styleUrl: './volume-kpi-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VolumeKpiGridComponent {
  @Input({ required: true }) totals!: VolumeTotals;
}
